import { DimensionEnum } from './../../../model/enum.model';
import { VisualizationAbstractScatterConfigModel } from "../visualization.abstract.scatter.model";
export class DaConfigModel extends VisualizationAbstractScatterConfigModel {
    constructor() {
        super(...arguments);
        this.dimension = DimensionEnum.THREE_D;
        this.domain = [-500, 500];
    }
}
